import { AssetsProtectionPayrollRGD } from './../../types/api'
import { useQuery } from '@tanstack/react-query'
import { QueryKeys } from 'constants/query-keys'
import { isStore } from 'utils/location'
import { TIME } from 'utils/misc'
import { useAnalytics } from 'utils/analytics'
import { fetchPayrollRGD } from 'queries/assets-protection/payroll/payroll-rgd'

export function useGetPayrollRGD({
    env,
    accessToken,
    location,
    filters,
    timeDimension,
}: AssetsProtectionPayrollRGD & { timeDimension: string }) {
    const { tenMinutes } = TIME
    const enabled = !isStore(location)
    const { trackEvent } = useAnalytics()

    const { data, isLoading, isError, refetch, remove, error } = useQuery(
        [QueryKeys.PAYROLL_RGD, location, timeDimension],
        () =>
            fetchPayrollRGD({
                env,
                accessToken,
                filters: {
                    ...filters,
                    time_dimension: timeDimension,
                },
                method: 'GET',
                trackEvent,
            }),
        {
            staleTime: tenMinutes,
            cacheTime: tenMinutes,
            enabled,
        },
    )

    return { data, isLoading, isError, refetch, remove, error }
}
